import { hasValue } from 'common/validations/field';
import defaultAdminFormValidations from 'common/validations/form/defaultAdmin';
import i18n from 'i18n';

const validateCreateAdminForm = (values) => {
  const errors = defaultAdminFormValidations(values);

  if (!hasValue(values.password)) {
    errors.password = i18n.t('emptyField', { ns: 'validations' });
  }

  return errors;
};

export default validateCreateAdminForm;
